import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { AlertList } from 'react-bs-notifier';
import { dismissNotification } from 'redux/modules/alertnotifier';
import './alert-notifier.css';

// TYPES: info, warning, danger, success
class AlertNotifier extends PureComponent {
    static propTypes = {
        dismissNotification: PropTypes.func.isRequired,
        alerts: PropTypes.array.isRequired
    }

    onDismiss = (data) => {
        this.props.dismissNotification(data.id);
    }

    render() {
        return (
            <div className='alert-notifier'>
                <AlertList
                    position='top-left'
                    alerts={this.props.alerts}
                    onDismiss={this.onDismiss} />
            </div>
        );
    }
}

function mapStateToProps({ alertnotifier }) {
    return {
        alerts: alertnotifier.alerts
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dismissNotification: (id) => {
            dispatch(dismissNotification(id));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertNotifier);
